<script lang="ts">
	import type { AvtalePerks } from "#lib/types/avtale.js";
	import {
		IconGift,
		IconHeartOutline,
		IconCheckOutline,
		IconPercent,
		IconSocial,
		IconSmartPhone,
	} from "@ishavskraft/shared";
	import { PortableText } from "@portabletext/svelte";
	interface Props {
		perks: AvtalePerks;
	}
	let { perks }: Props = $props();

	let icons = {
		gift: IconGift,
		heart: IconHeartOutline,
		customer_service: IconSocial,
		phone: IconSmartPhone,
		checkmark: IconCheckOutline,
		percent: IconPercent,
	};
</script>

<div class="mx-edge-x mb-8 tablet:mb-11">
	<h2>{perks.block_title}</h2>
	<div class="grid grid-cols-1 tablet:grid-cols-3 gap-6">
		{#each perks.perks?.filter(Boolean) ?? [] as perk (perk._key)}
			{@const Icon = icons[perk.icon as keyof typeof icons]}
			<div class="flex flex-row gap-3 items-start p-4">
				<Icon class="color-[--lysning] w-[50px] h-[50px] shrink-0" />
				<div class="*:m-0">
					<p class="font-bold mb-0">{perk.title}</p>
					<PortableText value={perk.description?.filter(Boolean)} />
				</div>
			</div>
		{/each}
	</div>
	{#if perks.description?.length}
		<PortableText value={perks.description?.filter(Boolean)} />
	{/if}
</div>
